module.exports = __webpack_public_path__ + "img/onHold-upArrow.06594d9a.svg";